@if (!isHidden) {
<section [class]="['mutara-expansion-panel','flex-full']">
    @if ( !!props.label ) {
    <div [class]="[props.viewStyle ?? '','mutara-expansion-panel-header']">
        <h2 class="mat-headline-2 flex-1">{{props.label}}</h2>
        @if ( addButton?.visible && !props?.readonly ) {
        <button mat-flat-button type='button' color="accent" [class]="'mutara-right'"
            (click)="showAdditionalData(null, 'more');">
            <mat-icon>add</mat-icon>
            <mat-label>Add<span class="sr-only">{{props.label}}</span></mat-label>
        </button>
        }
    </div>
    }
    @if ( !props.label ) {
    <div class="sr-only">
        {{field.key?.toString().replace('_',' ')}} Section
    </div>
    }
    @if ( !!props.description ) {
    <div [class]="['flex-full', 'mutara-subheader']">{{props.description}}</div>
    }

    @if ((!!props?.filterDate || !isHideSearch) || !!props.showDownload ) {
    <div [class]="['flex-full', 'display-flex', 'flex-right', 'mutara-subheader']">
        @if ( !!props?.readonly && !isHideSearch) {
        <span class='flex-1'>
            <mat-form-field class='search-button' (keydown.enter)="$event.preventDefault()">
                <mat-label>Search</mat-label>
                <input #search matInput (keyup)="applyFilter($event)" placeholder="ex: class">
            </mat-form-field>
        </span>
        }

        @if ( !!props?.filterDate ) {
        <span class="'flex-2">
            <formly-form [model]="dateModel" [fields]="dateFields" (modelChange)="applyDateFilter()"></formly-form>
        </span>
        }
        @if ( !!props?.showDownload ) {
        <button mat-flat-button type='button' color="accent" (click)="exportToCSV()">
            <mat-icon>download</mat-icon>Export to CSV
        </button>
        }
    </div>
    }

    <div class="mutara-expansion-panel-content">
        <table mat-table [class]="{'no-overflow': true}" [dataSource]="tableData" matSort>
            @for ( columnDefn of displayColumns; track columnDefn.key; let colindex = $index;) {
            <ng-container [matColumnDef]='columnDefn.key.toString()'>
                <mat-header-cell *matHeaderCellDef mat-sort-header [class]='"mutara-cell " + columnDefn.type'
                    [disabled]='columnDefn.type == "checkbox"'>
                    {{columnDefn.props?.label}}
                </mat-header-cell>
                <mat-cell *matCellDef="let row; let rowIndex = index;" [class]='"mutara-cell " + columnDefn.type'>
                    @switch ( columnDefn.props?.hrefType ?? columnDefn.type ) {
                    @case ( 'compact') {
                    <span [title]='columnDefn.props?.label' (click)="showAdditionalData(row, 'more')">&nbsp;</span>
                    }
                    @case ('button') {
                    <formly-field mat-flat-button [formlyAttributes]='columnDefn' [field]='columnDefn'
                        [title]='columnDefn.props?.label'
                        (click)='performButtonAction($event, columnDefn, row, rowIndex)'>
                        {{columnDefn.props?.description ?? columnDefn.props?.label }}</formly-field>
                    }
                    @case ('link') {
                    <a [href]='getHrefValue(columnDefn,row)'
                        [title]="getCellTitle(columnDefn,row)">{{getCellDisplay(columnDefn,row)}}</a>
                    }
                    @case ('checkbox') {
                    <mat-icon class="mutara-icon">
                        {{getCellDisplay(columnDefn, row, rowIndex) == true? 'check_circle' : ''}}
                    </mat-icon>
                    }
                    @case ('file') {
                    <mat-icon align="center" [class]="['mutara-icon','file']">
                        {{getCellDisplay(columnDefn,row )}}
                    </mat-icon>
                    }
                    @case( 'textarea') {
                        <formly-field [formlyAttributes]="columnDefn" [field]="columnDefn" [title]="columnDefn.props?.label">{{getCellDisplay(columnDefn,row)}}</formly-field>
                    }
                    @default {
                    <span [title]='getCellTitle(columnDefn,row)'>{{getCellDisplay(columnDefn,row)}}</span>
                    }
                    }
                    @if ( !props?.readonly && colindex == displayColumns.length - 1 ) {
                    <mat-icon class="mutara-icon-right">more_vert</mat-icon>
                    }
                </mat-cell>
            </ng-container>
            }
            <mat-header-row *matHeaderRowDef="listFields" class="mutara-header-row"></mat-header-row>
            <mat-row *matRowDef="let row; columns: listFields;let index = index"
                (click)="_selectRow(index, false);showAdditionalData(row, 'more');" class="mutara-relative"></mat-row>
        </table>
        <mat-paginator #paginator showFirstLastButtons [pageSize]='15'
            [class]="{ 'mutara-hidden' : (tableData?.data?.length ?? 0) < 15}" [length]="tableData.data.length"
            [pageSizeOptions]="[15, 30, 60]" role='navigation' aria-label="Select Data Page">
        </mat-paginator>
    </div>
</section>
}